import React, { FC } from "react";
import SlidingIconButton from "./SlidingIconButton";
import { useStore } from "../../store/store";

const HistoryButton: FC = () => {
  const { setArtworkInFront, isTourOpen } = useStore();
  const onClick = () => {
    setArtworkInFront(true);
  };
  return (
    <SlidingIconButton
      to="/history"
      color="text-white" // Tailwind CSS text color class
      text="Geschiedenis"
      iconClass="d-time-history" // Ensure this class includes the desired icon styles
      className="button-history hover:border-lavenderBlush"
      onClick={onClick}
      openByDefault={false}
      reverse={false}
      disabled={isTourOpen}
    />
  );
};

export default HistoryButton;
